<template>

    <div class="signup-page">
        <Header></Header>
        <section class="signup-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Create Campaign</h2>
                        <form class="form" v-on:submit="FormSubmit">
                            <div class="input-field form-input">
                                <label for="your-campaign">Campaign Name *</label>
                                <input type="text" placeholder="Campaign Name" v-model="campaign" id="your-campaign">
                            </div>
                            <div class="input-field form-input">
                                <label for="your-title">Title *</label>
                                <input type="text" placeholder="Title" v-model="title" id="your-title">
                            </div>
                            <div class="input-field form-input">
                                <label for="your-description">Description *</label>
                                <input type="text" placeholder="Description" v-model="description" id="your-description">
                            </div>
                            <div class="input-file-field form-input">
                                <p>Upload Image *</p>
                                <label for="image">
                                    <span>{{imageName}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="image" ref="image" v-on:change="handleVideoFileUpload">
                            </div>
                            <div class="input-select-field form-input">
                                <label for="your-artist">Link Artist * <span></span></label>
                                <select id="your-artist" v-model="artistId">
                                    <option value="">Choose Artist</option>
                                    <option :value="list._id" v-for="(list) in artists" v-if="artists" v-bind:key="list._id">{{list.name}} ({{list.email}})</option>
                                </select>
                            </div>
                            <div class="input-textarea-field form-input" v-if="FormSubmited">
                                <Progress interval="500" />
                            </div>

                            <div class="input-submit">
                                <button type="submit" v-if="!FormSubmited">SUBMIT</button>
                                <span v-if="FormSubmited">SUBMIT...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../Header'
    import Footer from '../Footer'
    import Progress from "../../include/Progress"
    import axios from 'axios'
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    import $ from 'jquery'
    Vue.use(VueToast)
    export default {
        name: 'AdminCampaignCreate',
        components: {
            'Header': Header,
            'Footer': Footer,
            Progress
        },
        data() {
            return {
                title: '',
                description: '',
                image: '',
                imageName: '',
                campaign: '',
                artistId: '',
                artists: '',
                FormSubmited: false,
                msg: 'Welcome to Your Vue.js App'
            }
        },
        mounted(){
            let userdata = localStorage.getItem('cbs_admin_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
                this.userData = userdata
                this.getAllArtist()
            }
        },
        methods: {
            getAllArtist: function(){
                axios
                    .get('/artists', {
                        role: 'artist'
                    })
                    .then(response => {
                        this.artists = response.data
                    })
                    .catch(error => {})
            },
            handleVideoFileUpload(){
                if(this.$refs.image.files[0]){
                    this.image = this.$refs.image.files[0]
                    this.imageName = this.$refs.image.files[0].name
                }
            },
            FormSubmit: function (event) {
                event.preventDefault()
                var $this = this
                this.FormSubmited = true
                const formData = new FormData()
                if(this.image && this.description && this.title && this.campaign && this.artistId){
                    formData.append('campaign', this.campaign)
                    formData.append('title', this.title)
                    formData.append('description', this.description)
                    formData.append('image', this.image)
                    formData.append('imageName', this.imageName)
                    formData.append('artist', this.artistId)
                    try {
                        axios.post('/createCampaign', formData,{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userData.token
                            }
                        }).then(res => {
                            // location.reload()
                            $this.FormSubmited = false
                            console.log(res)
                        }).catch(err => {
                            $this.FormSubmited = false
                            console.log(err)
                        })
                    } catch (e) {
                        console.log(e)
                    }
                } else {
                    this.FormSubmited = false
                    Vue.$toast.open(
                        {
                            message: 'Fill all the fields',
                            type: 'error',
                            position: 'top-right'
                        }
                    )
                }
            },
            FormSubmit1: function (event) {
                event.preventDefault()
                var $this = this
                axios.post('/createCampaign', {
                    title: this.title,
                    description: this.description,
                    artist: '5de5d46a2aedf53e6d6ffd55'
                },{
                    headers: {
                        "content-type": "application/json",
                        "x-api-key": this.userData.token
                    }
                }).then(function (response) {
                    // location.reload()
                    $this.FormSubmited = false
                    Vue.$toast.open(
                        {
                            message: 'Submitted successfully!',
                            type: 'success',
                            position: 'top-right'
                        }
                    )
                    $this.FormSubmited = false
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/campaign/Create.vue